#import "../fragments/competitors-lead-fragment.graphql"

mutation RemoveCompetitorFromLead($input: LeadCompetitorRemoveInput!) {
    leadCompetitorRemove(input: $input) {
        lead {
            ...CompetitorsLeadFragment
        }
    }
}
